import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { IconLabelComponent } from '../icon-label/icon-label.component';

@Component({
    selector: 'section2',
    templateUrl: './section2.html',
    styleUrls: ['./section2.scss'],
    standalone: true,
    imports: [RouterLink, TranslationModule, IconLabelComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class Section2Component {
    @Input()
    sectionIcon = '';

    @Input()
    sectionTitle = '';

    @Input()
    sectionSubtitle = '';

    @Input()
    sectionCta = 'View';

    @Input()
    sectionCtaLink = '';
}
